/**
 * css缓存
 *
 * @author yusangeng@outlook.com
 */
import { Cache, CacheStatus } from './cache';
import { getInstance } from '../singleton';
var cssCache = getInstance('cssCache', function () {
    return new Cache(function (key) {
        return {
            url: key,
            status: CacheStatus.NONE,
            el: null,
            error: null,
            reject: null
        };
    });
});
export default cssCache;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3NzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NhY2hlL2Nzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUgsT0FBTyxFQUFFLEtBQUssRUFBYSxXQUFXLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFDdkQsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQU0xQyxJQUFNLFFBQVEsR0FBRyxXQUFXLENBQUMsVUFBVSxFQUFFO0lBQ3ZDLE9BQU8sSUFBSSxLQUFLLENBQWUsVUFBQyxHQUFXO1FBQ3pDLE9BQU87WUFDTCxHQUFHLEVBQUUsR0FBRztZQUNSLE1BQU0sRUFBRSxXQUFXLENBQUMsSUFBSTtZQUN4QixFQUFFLEVBQUUsSUFBSTtZQUNSLEtBQUssRUFBRSxJQUFJO1lBQ1gsTUFBTSxFQUFFLElBQUk7U0FDYixDQUFBO0lBQ0gsQ0FBQyxDQUFDLENBQUE7QUFDSixDQUFDLENBQUMsQ0FBQTtBQUVGLGVBQWUsUUFBUSxDQUFBIn0=